
import { defineComponent, reactive, toRefs } from "vue";
import { getGateways, deleteGateway } from "../composables/api";
import { GatewaysTableDataType } from "@/types/components";
import { Gateway } from "../types";
import { openNotificationWithIcon } from "@/composables/utils";
import CreateGatewayModal from "./CreateGatewayModal.vue";
import PeripheralsTable from "./PeripheralsTable.vue";

import { Table, Popconfirm, Button } from "ant-design-vue";
import {
  DeleteOutlined,
  PlusOutlined,
  ClusterOutlined,
} from "@ant-design/icons-vue";
import "ant-design-vue/lib/table/style/css";
import "ant-design-vue/lib/popconfirm/style/css";

export default defineComponent({
  name: "GatewaysTable",
  components: {
    ATable: Table,
    AButton: Button,
    DeleteOutlined,
    APopconfirm: Popconfirm,
    PeripheralsTable,
    CreateGatewayModal,
    PlusOutlined,
    ClusterOutlined,
  },
  setup() {
    const data: GatewaysTableDataType = reactive({
      columns: [
        {
          title: "Serial Number",
          dataIndex: "serialNumber",
          key: "serialNumber",
        },
        {
          title: "Label",
          dataIndex: "label",
          key: "label",
        },
        {
          title: "IPv4 address",
          dataIndex: "address",
          key: "address",
        },
        {
          title: "Actions",
          key: "actions",
        },
      ],
      gateways: [],
      isLoading: true,
      createGatewayModalVisibility: false,
      peripheralsModalVisibility: false,
      expandedRows: [],
      rowHasBeenExpanded: false,
    });

    const onDeleteGateway = async (gateway: Gateway) => {
      try {
        data.isLoading = true;
        await deleteGateway(gateway._id);
        openNotificationWithIcon("success", "Gateway succesfully deleted");
        await refreshGateways();
      } catch (error) {
        console.error("Error while deleting gateway: ", error);
      } finally {
        data.isLoading = false;
      }
    };

    const refreshGateways = async () => {
      try {
        data.isLoading = true;
        data.gateways = await getGateways();
      } catch (error) {
        console.error("Error while getting gateways");
      } finally {
        data.isLoading = false;
      }
    };

    const gatewayCreated = async () => {
      data.createGatewayModalVisibility = false;
      await refreshGateways();
    };

    const toggleRow = (
      expandable: boolean,
      expanded: boolean,
      record: Gateway
    ) => {
      if (!expandable) return;
      data.rowHasBeenExpanded = true;
      if (!expanded) {
        data.expandedRows.push(record.serialNumber);
      } else {
        data.expandedRows.splice(
          data.expandedRows.indexOf(record.serialNumber),
          1
        );
      }
    };

    refreshGateways();

    return {
      ...toRefs(data),
      onDeleteGateway,
      gatewayCreated,
      refreshGateways,
      toggleRow,
    };
  },
});
